import React from 'react';

import { useSlider } from '@/hooks/useSlider';
import { useVitrineTagging } from '@/hooks/useVitrineTagging';
import { IEventsTag } from '@/hooks/useVitrineTagging/types';

import { ButtonsSlider } from '@/components/global/ButtonSlider';

import {
  TCard,
  TRecommendation,
} from '@/services/requests/Recommendation/types/template7';

import { Card } from './Card';
import { SliderDots } from './SliderDots';

export type TProps = {
  data: TRecommendation;
};

export const Slider = ({ data }: TProps) => {
  const { cards, layout, events_tag, title } = data;

  const { sliderState, moveSlider, containerRef, checkScrollLimit } = useSlider(
    data,
    'tabName',
    true,
    layout?.toString(),
    'vitrine-template7__cards__card',
  );

  const { triggerSelectContentClick } = useVitrineTagging({
    events_tag: events_tag as IEventsTag,
    title,
  });

  const handleCardClick = (
    _: React.MouseEvent<HTMLAnchorElement>,
    card: TCard,
  ) => {
    triggerSelectContentClick({
      type: 'card',
      title: card.title.text,
    });
  };

  return (
    <div className="vitrine-template7__slider" data-testid="slider">
      <ButtonsSlider
        handleClick={moveSlider}
        sliderScroll={sliderState.scroll}
        checkScrollLimit={checkScrollLimit}
        template="7"
      />
      <div
        className="vitrine-template7__cards"
        ref={containerRef}
        data-testid="cards"
      >
        {cards.map(card => (
          <Card
            key={card.id}
            data={card}
            cards={cards}
            containerRef={containerRef}
            recommendationId={data.id}
            onClick={handleCardClick}
          />
        ))}
      </div>
      <SliderDots
        cards={cards}
        currentSlide={sliderState.current}
        template="vitrine-template7__slider-dot"
      />
    </div>
  );
};
